export const MOCK_PREDEFINED_COMMENTS = [
  'Predefined option 1',
  'Predefined option 2',
  'Predefined option 3',
];

export const MOCK_MITIGATE_DATA = [
  {
    id: '1',
    title: 'SAVMC001 Master Data Controls/Monitoring ',
    description: 'Controls over changes to master data involved are in place.',
    priority: 'High',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: true,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '12/30/25 0:00',
    comment: '',
  },
  {
    id: '2',
    title: 'SAVMC003 AP Voucher Entry and Vendor Master Maintenance',
    description:
      'Periodic review of Vendor Masterfile change for suspicious activity.',
    priority: 'Medium',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '12/30/25 0:00',
    comment: '',
  },
  {
    id: '3',
    title: 'SAVMC005',
    description: 'Maintain an invoice and enter or change payments against it.',
    priority: 'Low',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '1/1/26 0:00',
    comment: '',
  },
  {
    id: '4',
    title: 'SAVMC007 Payroll Processing Review',
    description:
      'Ensure payroll transactions comply with policies and regulations.',
    priority: 'High',
    mitigateType: 'Manual',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '10/15/26 0:00',
    comment: '',
  },
  {
    id: '5',
    title: 'SAVMC009 IT System Access Audit',
    description: 'Regularly review and audit system access permissions.',
    priority: 'Medium',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '6/30/25 0:00',
    comment: '',
  },
  {
    id: '6',
    title: 'SAVMC011 Segregation of Duties in Procurement',
    description:
      'Ensure proper separation of responsibilities in purchasing approvals.',
    priority: 'High',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: true,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '12/15/25 0:00',
    comment: '',
  },
  {
    id: '7',
    title: 'SAVMC013 Journal Entry Review and Approval',
    description:
      'Ensure all journal entries are properly reviewed and approved.',
    priority: 'Medium',
    mitigateType: 'Manual',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '9/30/25 0:00',
    comment: '',
  },
  {
    id: '8',
    title: 'SAVMC015 Financial Reporting Validation',
    description:
      'Regular validation of financial reports for accuracy and completeness.',
    priority: 'Low',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: true,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '3/1/26 0:00',
    comment: '',
  },
  {
    id: '9',
    title: 'SAVMC017 User Access Management',
    description:
      'Ensure timely revocation of access rights for inactive users.',
    priority: 'High',
    mitigateType: 'Configurable',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '11/10/26 0:00',
    comment: '',
  },
  {
    id: '10',
    title: 'SAVMC019 Compliance with Data Privacy Regulations',
    description:
      'Implement controls to comply with GDPR and other data privacy laws.',
    priority: 'Medium',
    mitigateType: 'Manual',
    isSelected: false,
    isRecommended: false,
    isCritical: false,
    selectedDates: {
      startDate: null,
      endDate: null,
    },
    expirationDate: '5/15/25 0:00',
    comment: '',
  },
];
